/*
 * snapped-tabs.js — tab switching for the Snapped product tabs section.
 * Theme blocks render in place via {% content_for "blocks" %}, so the old pure-CSS
 * (radio :checked) mechanism isn't possible. This builds the tab nav from the rendered
 * panels and switches by toggling .is-active — producing the SAME markup/classes/visuals.
 *
 * Progressive enhancement: without JS the panels render stacked (and the nav is hidden via
 * CSS that only activates once `.cpt-js` is added here). Idempotent + re-runs on section load.
 */
(function () {
  'use strict';

  function initTabs(root) {
    (root || document).querySelectorAll('[data-cpt-tabs]').forEach(function (wrap) {
      if (wrap.dataset.cptBound) return;
      var nav = wrap.querySelector('[data-cpt-nav]');
      var panels = wrap.querySelectorAll('.cpt-panel');
      if (!nav || panels.length === 0) return;
      wrap.dataset.cptBound = 'true';
      wrap.classList.add('cpt-js');

      var tabs = [];
      panels.forEach(function (panel, i) {
        var label = panel.getAttribute('data-cpt-label') || ('Tab ' + (i + 1));
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cpt-tab';
        btn.setAttribute('role', 'tab');
        btn.textContent = label;
        if (panel.id) btn.setAttribute('aria-controls', panel.id);
        nav.appendChild(btn);
        tabs.push(btn);
      });

      function activate(i) {
        tabs.forEach(function (t, idx) {
          var on = idx === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p, idx) {
          p.classList.toggle('is-active', idx === i);
        });
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { activate(i); });
        t.addEventListener('keydown', function (e) {
          var n;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { n = (i + 1) % tabs.length; }
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { n = (i - 1 + tabs.length) % tabs.length; }
          else { return; }
          e.preventDefault();
          tabs[n].focus();
          activate(n);
        });
      });

      activate(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTabs(document); });
  } else {
    initTabs(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initTabs(e.target); });
})();
